export default class UserRoute{
    constructor(attrs) {
        this.login = 'login';
        this.cookiesLogin = 'login/cookies';
        this.googleLogin = 'google-login'
    }
}
